import { useMutation, useQuery } from "@tanstack/react-query";
import { axiosInstanceAuth } from "./client";
import {
	BaseResponse,
	ErrorResponse,
	IMachine,
	IMachineStatus,
} from "interfaces";
import { AxiosError } from "axios";

export const useGetMachineStatus = (
	onErr?: (err: AxiosError<ErrorResponse>) => void
) => {
	return useMutation({
		mutationFn: async (statusCode: string) => {
			const res = await axiosInstanceAuth.get(
				`/status/clean_system?status_code=${statusCode}`
			);
			return res as BaseResponse<IMachineStatus>;
		},
		onError: (err) => {
			onErr && onErr(err as AxiosError<ErrorResponse>);
		},
	});
};

export const useGetListMachine = () => {
	return useQuery({
		queryKey: ["GET LIST MACHINE"],
		queryFn: async () => {
			const res = await axiosInstanceAuth.get("/statuses");
			return res as BaseResponse<IMachine[]>;
		},
	});
};
